import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpBackend, provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

import { provideCosmosCore } from '@btgdigital/cosmos/core';
import { environment } from '@environments/environment';
import { AddScriptService } from '@shared/services/add-script.service';



import { APP_BASE_HREF } from '@angular/common';

export function HttpLoaderFactory(http: HttpBackend) {

  const suffix = `.json`;

  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/login-', suffix }
  ]);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideCosmosCore(),
    provideHttpClient(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
      fallbackLang: 'pt-br',
      lang: 'pt-br'
    }),
    provideAppInitializer(() => {
      const addScriptService = inject(AddScriptService);
      addScriptService.addGoogleTagManager(environment.GTM_CONTAINER_ID, {
        baseUrl: environment.GTM_BASE_URL,
        dataLayerName: 'dataLayer'
      });
      // addScriptService.addExternalScript(environment.TOPAZ, 'head', { id: 'topaz-js' }).catch(() => {});
    }),
    provideHttpClient(
      withInterceptors([])
    ),
    { provide: APP_BASE_HREF, useValue: environment.ONSHORE ? '/noticias/' : '/news/' }
  ],

};
